import React from "react"

import Header from "../../../components/header";
import BannerContent from "../../../components/header/banner-content";



const BannerSlider = () => {
    return (
        <section className="banner-wrap">
            <Header />
            <BannerContent />
        </section>
    );
  }
  
  export default BannerSlider;